<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddMeal()">Add Meal</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDeposit()">Deposit</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPay()">Pay/Waive</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onRefund()">Refund</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdjust()">Adjust</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onView()">View Details</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print History</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstResult"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedResult"
		dataKey="ResultID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FineDT-->
				<th>
					<p-columnFilter type="text" field="FineDT" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AccountTypeCD-->
				<th>
					<p-columnFilter field="AccountTypeCD" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAccountTypeCD
								[ngModel]="value"
								[options]="lstAccountTypeCD"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--MealTypeDesc-->
				<th>
					<p-columnFilter field="MealTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterMealTypeDesc
								[ngModel]="value"
								[options]="lstMealTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Charged-->
				<th>
					<!-- <p-columnFilter type="text" field="Charged" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Adjusted-->
				<th>
					<!-- <p-columnFilter type="text" field="Adjusted" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Paid-->
				<th>
					<!-- <p-columnFilter type="text" field="Paid" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Balance-->
				<th>
					<!-- <p-columnFilter type="text" field="Balance" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="FineDT">Date/Time<p-sortIcon field="FineDT"></p-sortIcon></th>
				<th pSortableColumn="AccountTypeCD">Transaction<p-sortIcon field="AccountTypeCD"></p-sortIcon></th>
				<th pSortableColumn="MealTypeDesc">Meal Type<p-sortIcon field="MealTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="Charged">Charged<p-sortIcon field="Charged"></p-sortIcon></th>
				<th pSortableColumn="Adjusted">Adjusted<p-sortIcon field="Adjusted"></p-sortIcon></th>
				<th pSortableColumn="Paid">Paid<p-sortIcon field="Paid"></p-sortIcon></th>
				<th pSortableColumn="Balance">Balance<p-sortIcon field="Balance"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Result>
			<tr [pSelectableRow]="Result" (dblclick)="onRowDblClick(Result)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Result[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
